import {PENDING_FETCH_DRAFT, SUCCESS_FETCH_DRAFT, FAILED_FETCH_DRAFT} from "./mdTypes"

const initialState = {
    "pending_fetch": true,
    "failed_fetch": false,
    "fetch_complete": false,
    "fetched_draft": null
}

const mdReducer = (state= initialState, action) => {
    switch (action.type) {
        case PENDING_FETCH_DRAFT: return {
            ...state,
            "pending_fetch": true,
            "failed_fetch": false,
            "fetch_complete": false,
            "fetched_draft": null
        }

        case SUCCESS_FETCH_DRAFT: return {
            ...state,
            "pending_fetch": false,
            "failed_fetch": false,
            "fetch_complete": true,
            "fetched_draft": action.payload
        }

        case FAILED_FETCH_DRAFT: return {
            ...state,
            "pending_fetch": false,
            "failed_fetch": true,
            "fetch_complete": true,
            "fetched_draft": null
        }
    
        default: return state
    }
}

export default mdReducer